// Which screens belong to which of the business's homes, and whether one may show (Stage 4.2b O1b step 7). Pure —
// scripts/check-business.cjs calls these very functions and compares them with the server's own (ai/business.js).
//
// UNTIL THE BUSINESS HAS BEEN READ, EVERYTHING SHOWS — exactly what every tenant saw before business types existed. A
// menu that hid a home for the second it took to load would flash the wrong thing, and a tenant who never chose a
// type is answered "every home on" by the server anyway.

// The homes that can be switched, in the server's order.
export const MODULES = Object.freeze(["appointments", "orders"]);
export const BUSINESS_TYPES = Object.freeze(["clinic", "salon", "restaurant", "shop", "services", "real_estate", "other"]);

// The screens each home holds. A screen not listed belongs to every business.
export const VIEW_MODULE = Object.freeze({ calendar: "appointments", orders: "orders", catalog: "orders", ordersettings: "orders" });

export const moduleOn = (modules, module) => !modules || modules[module] !== false;
export const viewAllowed = (view, modules) => { const m = VIEW_MODULE[view]; return !m || moduleOn(modules, m); };

// What choosing a type does to the switches: its preset, except that a home still in use stays on — the server keeps
// it on too, and says so.
export function modulesForType(type, presets, inUse) {
  const preset = presets?.[type];
  if (!preset) return null;
  const out = {};
  for (const m of MODULES) out[m] = preset[m] === true || (inUse?.[m]?.length ?? 0) > 0;
  return out;
}

// A home that cannot be switched off right now, because actions in it are on.
export const lockedOn = (inUse, module) => (inUse?.[module]?.length ?? 0) > 0;

// What the page sends: the type and the switches, only when something differs from what is saved.
export function businessPatch(form, saved) {
  if (!form?.type) return null;
  const changed = form.type !== saved?.type || MODULES.some((m) => form.modules?.[m] !== saved?.modules?.[m]);
  return changed ? { type: form.type, modules: Object.fromEntries(MODULES.map((m) => [m, !!form.modules?.[m]])) } : null;
}
